import apiClient from './apiClient';

export const getProfile = () => apiClient.get('/me');
export const updateProfile = (data) => apiClient.patch('/me', data);
export const getStats = () => apiClient.get('/me/stats');
export const getActivity = (limit = 20, offset = 0) => apiClient.get(`/me/activity?limit=${limit}&offset=${offset}`);

export const requestNftChallenge = (address) => apiClient.post('/me/nft-challenge', { address });
export const verifyNftHolder = (address, proof) => apiClient.post('/me/nft-verify', { address, ...proof });
export const getMyNfts = () => apiClient.get('/me/nfts');
export const getMyNftImage = (tokenId) => apiClient.get(`/me/nfts/${tokenId}/image`, { responseType: 'blob' });
export const sendTelegramTestMessage = () => apiClient.post('/me/connections/telegram/test');
